import { postFakeLogin } from "../../helpers/fakebackend_helper";
import { apiError, loginSuccess, logoutUserSuccess, reset_login_flag } from "./reducer";

const defaultAuth = process.env.REACT_APP_DEFAULTAUTH;

export const loginUser = (user: any, history: any) => async (dispatch: any) => {
    try {
      let response;
        response = await postFakeLogin({
          email: user.email,
          password: user.password,
        });
  
      var data = await response;
  
      if (data) {
        localStorage.setItem("loginUser", JSON.stringify(data));
        if (defaultAuth === "fake") {
          var finalLogin: any = JSON.stringify(data);
          finalLogin = JSON.parse(finalLogin);
          data = finalLogin.data;
          if ((finalLogin.status === "success") || (finalLogin.username && finalLogin.password)) {
            dispatch(loginSuccess(data));
            history("/index");
          } else {
            history.push("/auth-login");
            dispatch(apiError(finalLogin));
          }
        } else {
          dispatch(loginSuccess(data));
          history.push("/index");
        }
      }
    } catch (error) {
      dispatch(apiError(error));
    }
  };

export const logoutUser = (history : any) => async (dispatch : any) => {
  try {
    localStorage.removeItem("loginUser");
      dispatch(logoutUserSuccess(true));
      history('/auth-login')
    // }

  } catch (error) {
    dispatch(apiError(error));
  }
};

export const socialLogin = (type : any, history : any) => async (dispatch : any) => {

  try {
    let response;
    const socialData = await response;

    if (socialData) {
      localStorage.setItem("loginUser", JSON.stringify(socialData));
      dispatch(loginSuccess(socialData));
      history('/index');
    }

  } catch (error) {
    dispatch(apiError(error));
  }
};

export const resetLoginFlag = () => async (dispatch : any) => {
  try {
    const response = dispatch(reset_login_flag());
    return response;
  } catch (error) {
    dispatch(apiError(error));
  }
};